// clinic.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { ClinicDto } from '../../shared/models/franchise/franchise.model';
import * as ClinicActions from './clinics.actions';

export interface ClinicState {
  clinics: ClinicDto[] | null;
  selectedClinicContext: ClinicDto | null;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: ClinicState = {
  clinics: null,
  selectedClinicContext: null,
  error: null,
  loaded: false,
  loading: false,
};

export const clinicsReducer = createReducer(
  initialState,
  on(ClinicActions.loadClinics, (state) => ({
    ...state,
    loading: true,
  })),
  on(ClinicActions.loadClinicsSuccess, (state, { clinics }) => {
    return {
      ...state,
      clinics,
      loaded: true,
      loading: false,
      error: null,
    };
  }),
  on(ClinicActions.loadClinicsFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: false,
    loading: false,
  })),
  on(ClinicActions.setSelectedClinicContext, (state, { clinic }) => ({
    ...state,
    selectedClinicContext: clinic,
  })),
  on(ClinicActions.clearSelectedClinicContext, (state) => ({
    ...state,
    selectedClinicContext: null,
  }))
);
